import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
  ViewChild
} from '@angular/core';
import {CesiumAdapterService} from "./services/cesiumAdapter21/cesium-adapter.service";
import {EventConfigProvider} from "./classes/EventConfigProvider";
import {ItemManagerService} from "./services/itemManager/item-manager.service";
import {ServerConnectionService} from "./services/serverConnection/server-connection.service";
import {LoggerService} from "../logger/logger.service";
import {ItemConfig} from "./models/ItemConfig";
import {OverlayService} from "./services/overlay/overlay.service";
import {Item} from "./models/Item";
import {isBigEventOptimization, isViewMode} from 'src/configs/view_only';
import {CalculateInputsService} from "./services/calculateInputsService/calculate-inputs.service";
import {MapPosition} from "./models/MapPosition";
import {KeyListenersService} from "./services/keyListenersService/key-listeners.service";
import {EsBsModalService} from "./services/bsModalService/bs-modal.service";
import {CookieService} from "./services/coockieService/coockie.service";
import {UiAdapterService} from "./services/uiAdapterService/ui-adapter.service";
import {debounceTime, filter, switchMap, take, tap, takeWhile} from "rxjs/operators";
import {DrawingEditorToolsComponent21} from "./components_2.1/drawing-editor-tools/drawing-editor-tools.component";
import {StorySlidesComponent} from "./components_2.1/story-slides/story-slides.component";
import {DynamicScriptLoaderService, ScriptStore} from "./services/scriptService/DynamicScriptLoaderService";
import {Observable, timer} from "rxjs";
import {ES_APP_VERSION} from "./interfaces/constants";
import {UserGuideService} from '@modules/user-guide/shared/user-guide.service';
import {GroupService} from "./services/groupService/group-service.service";
import { ToolsService } from './services/toolsService/tools.service';
import {Md5} from 'ts-md5';
import { StoryService } from './services/storyService/story.service';
import { TimelineService } from './services/timeline/timeline.service';
import moment from "moment";
import {PaywallUserService} from '@modules/paywall/services/paywallUserService/paywall-user.service';
declare var Yiit;
declare var google;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, AfterViewInit{
  public isViewMode = isViewMode;
  public socketPort = window['SOCKETIO_PORT'];
  public Yiit = Yiit;
  public isLabelsActive = true;
  public isHoverOn = false;
  public all_items:any = [];
  private collectObjectList:boolean = false;

  private socketConnectionModalTimer = null;
  private itemsPositions = [];

  @ViewChild(DrawingEditorToolsComponent21, {static: false}) drawingEditorToolsComponent: DrawingEditorToolsComponent21;
  @ViewChild(StorySlidesComponent, {static: false}) storySlidesComponent: StorySlidesComponent;

  constructor(
    protected dynamicScriptLoader: DynamicScriptLoaderService,
    protected view: CesiumAdapterService,
    protected itemManager: ItemManagerService,
    protected serverConnection: ServerConnectionService,
    protected overlayService: OverlayService,
    protected logger: LoggerService,
    protected calculateItemInputsService: CalculateInputsService,
    protected cd: ChangeDetectorRef,
    protected kl: KeyListenersService,
    protected modalControl: EsBsModalService,
    protected cookieService: CookieService,
    protected uiAdapterService: UiAdapterService,
    protected userGuideService: UserGuideService,
    protected gs: GroupService,
    protected toolsService: ToolsService,
    protected storyService: StoryService,
    protected timelineService: TimelineService,
    protected paywallS: PaywallUserService,
    protected ngZone: NgZone
    ) { }

    ngOnInit(): void {
      this.storyService.appComponent = this;
      window['isLabelsActive'] = true;
      this.loadScripts()
        .pipe(
          tap(() => this.initializeViewListeners()),
          tap(() => this.initializeServerConnection()),
          filter(() => !(this.userGuideService.isFastSignup && !this.userGuideService.isPlaceSet())),
          switchMap(() => EventConfigProvider())
        )
        .subscribe(eventConfig => {
          this.view.render(
            eventConfig.center.lat !== 0 || eventConfig.center.lat !== 0
              ? eventConfig.center
              : {lat: 51.4936682, lng: -0.0981403}
          );

          window['oneplanShowLabels'] = () => {
            this.showAllLabels();
            return true;
          };

          window['oneplanHideLabels'] = () => {
            this.hideAllLabels();
            return true;
          };

          EventConfigProvider().subscribe((eventConfig) => {
            this.initializeServerConnection();
            window['getViewRectangleFromCentrepoint'] = () => {
              console.log('=== getViewRectangleFromCentrepoint ===');
              return this.view.getViewRectangleFromCentrepoint();
              // return this.view.getViewRectangle();
            };
            window['oneplanGetCurrentBounds'] = () => {
              console.log('=== oneplanGetCurrentBounds ===');
              return this.view.getViewRectangleFromCentrepoint();
              //return this.view.getViewRectangle();
            };
            window['oneplanGetCurrentBoundsAlt'] = () => {
              console.log('=== oneplanGetCurrentBoundsAlt ===');
              return this.view.getViewRectangleAlt();
              // return this.view.getViewRectangle();
            };
            window['oneplanGetCurrentHeading'] = () => {
              console.log('=== oneplanGetCurrentHeading ===');
              return this.view.getViewHeading();
              // return this.view.getViewRectangle();
            };
            window['oneplanSetCurrentHeading'] = (val) => {
              console.log('=== oneplanGetCurrentHeading ===');
              return this.view.setViewHeading(val);
              // return this.view.getViewRectangle();
            };
            window['oneplanSetTimelineEnabled'] = (val) => {
              window['TIMELINE_ENABLED'] = val;
              return val;
              // return this.view.getViewRectangle();
            };
            window['oneplanSetTimelineToTime'] = (val) => {
              if (!val) {
                return;
              }
              this.timelineService.isActive = true;

              let d = moment(val);
              let dateTimeStr = d.format('YYYY-MM-DD hh:mm');
              let timelineConfig = {
                "time_window_name": null,
                "datetime_start": dateTimeStr,
                "datetime_end": dateTimeStr,
                "is_generic": 1,
                "info": {
                  "generic_config": {
                    "granularity": {
                      "step": "15m",
                      "stepMs": 900000
                    }
                  }
                }
              }
              console.log('this.timelineService.timeline_slider 555555555555555555', this.timelineService.timeline_slider);
              this.timelineService.timeline_slider.setSliderInterval(timelineConfig);

              // this.timelineService.setTime(val);
              // this.timelineService.setTimelineVisible(true);
              this.timelineService.timeline_slider.defaultTimeValue = val;
              this.timelineService.forceShowTimelineSlider();
              this.timelineService.timeline_slider.setTime(val);
              return val;
              // return this.view.getViewRectangle();
            };
            window['oneplanRemoveTimeline'] = () => {
              this.timelineService.setTime(null);
              // this.timelineService.isActive = false;
              // this.timelineService.setTimelineVisible(false);
              this.timelineService.forceHideTimelineSlider();
              return true;
              // return this.view.getViewRectangle();
            };
            this.itemManager.itemsList.pipe(debounceTime(1000)).subscribe((list) => {
              if (!this.collectObjectList) return;
              let all_items_obj: any = {};
              this.all_items = [];
              for (let i in list) {
                let item: any = list[i];
                let item_config: any = item.config;

                //let fixed_layer_info = (typeof item_config.fixedLayerId !== 'undefined') ? this.fixedLayersAdapter.getById(item_config.fixedLayerId).asSimpleObject() : null;
                //let version = this.versionsService.getCurrentVersion();
                //console.log('fixed_layer_info', fixed_layer_info);

                for (let o in item_config.objects) {
                  let object = item.objects[o];
                  let tool: any = this.toolsService.getToolById(object.tool_id);
                  let map_overlay_config: any = object.asSimpleObject();
                  let input_config: any = item_config.inputs;
                  let object_tmp = {
                    item_id: item_config.getId(),
                    input_config: input_config,
                    map_overlay_config: map_overlay_config,
                    group_id: (typeof item_config.groupId !== 'undefined') ? item_config.groupId : null,
                    tool_id: (typeof object.tool_id !== 'undefined') ? object.tool_id : null,
                    tool: (typeof tool !== 'undefined') ? tool : null,
                    //fixed_layer_id: (typeof item_config.fixedLayerId !== 'undefined') ? item_config.fixedLayerId : null,
                    //fixed_layer_info: fixed_layer_info,
                    //version: version,
                  }
                  let unique_key: any = Md5.hashStr(JSON.stringify(object_tmp));
                  all_items_obj[unique_key] = object_tmp;
                }
              }
              //console.log('this.all_items', JSON.stringify(this.all_items));
              for (let i in all_items_obj) {
                this.all_items.push(all_items_obj[i]);
              }
            });

            window['oneplanGetItemList'] = () => {
              return this.all_items;
            };
            window['oneplanEnableGetItemList'] = () => {
              this.collectObjectList = true;
              return this.collectObjectList;
            };

          });

          console.log('ES_APP_VERSION', ES_APP_VERSION);
        });
    }

  private loadScripts(){
    return new Observable((observer) => {
      let scriptNames = ScriptStore.map((script)=>{
        return script.name;
      });
      this.dynamicScriptLoader.load(...scriptNames).then((data )=>{
        observer.next(data);
        observer.complete();
      });
    })
  }

  private getCalculatedEventCenterPosition(){
    if (this.itemsPositions.length === 0){
      return null;
    }
    let average = {latitude: 0, longitude: 0};

    this.itemsPositions.forEach((val)=>{
      average.latitude += val.latitude/this.itemsPositions.length;
      average.longitude += val.longitude/this.itemsPositions.length;
    });

    let dispersion = 0;
    let itemsDistance = [];

    this.itemsPositions.forEach((position)=>{
      let _distance = (Cesium.Cartesian3.distance(this.view.cesiumConverter.convertFromDegreesToCartesian(position), this.view.cesiumConverter.convertFromDegreesToCartesian(average)));
      itemsDistance.push(_distance);
      dispersion += Math.pow(_distance, 2);
    });

     dispersion=dispersion/this.itemsPositions.length;
    let maximumDistanceInMeters = Math.sqrt(dispersion);
    let resultItemsPosInCenterBounds = this.itemsPositions.filter((item, index) => itemsDistance[index] < maximumDistanceInMeters);
    let rectangle = Cesium.Rectangle.fromCartesianArray(resultItemsPosInCenterBounds.map((pos) => {
      return this.view.cesiumConverter.convertFromDegreesToCartesian(pos);
    }));

    return rectangle;
  }

  public showAllLabels(){
    this.view.disableDrawLabelsMode();

    this.isLabelsActive = true;
    this.itemManager.itemsList.pipe(debounceTime(500)).subscribe((itemList:Item)=>{
      for (let i in itemList){
        let _item:Item = itemList[i];
        _item.toggleLabelVisibility(this.isLabelsActive);
      }
      // item.toggleLabelVisibility(this.isLabelsActive);
    });

    setTimeout(() => { this.view.drawLabels(); }, 500);

    try {
      this.cd.detectChanges();
    } catch (e) {
      console.log('app component detectChanges error');
    }

    window['isLabelsActive'] = this.isLabelsActive;
  }

  public hideAllLabels(){
    this.view.disableDrawLabelsMode();
    console.error('hideAllLabels');
    this.isLabelsActive = false;
    this.itemManager.itemsList.pipe(debounceTime(500)).subscribe((itemList:Item)=>{
      for (let i in itemList){
        let _item:Item = itemList[i];
        _item.toggleLabelVisibility(this.isLabelsActive);
      }
      // item.toggleLabelVisibility(this.isLabelsActive);
    });

    setTimeout(() => { this.view.drawLabels(); }, 500);

    this.cd.detectChanges();
    window['isLabelsActive'] = this.isLabelsActive;
  }

  toggleAllLabels(){
    this.view.disableDrawLabelsMode();

    this.isLabelsActive = !this.isLabelsActive;
    this.itemManager.itemsList.pipe(debounceTime(500)).subscribe((itemList:Item)=>{
      for (let i in itemList){
        let _item:Item = itemList[i];
        _item.toggleLabelVisibility(this.isLabelsActive);
      }
      // item.toggleLabelVisibility(this.isLabelsActive);
    });

    setTimeout(() => { this.view.drawLabels(); }, 500);

    this.cd.detectChanges();
    window['isLabelsActive'] = this.isLabelsActive;
  }
  setEyeHover(flag){
    this.isHoverOn = flag;
    this.cd.detectChanges();
  }

  getCurrentEyeIcon() {
    if (this.isHoverOn) {
      return this.isLabelsActive ? 'eye-slash' : 'eye';
    } else {
      return this.isLabelsActive ? 'eye' : 'eye-slash';
    }
  }

  private initializeViewListeners() {
    const self = this;
    this.view.adapterInitialized.subscribe(
      (isLoaded) => {
        if (isLoaded) {
          this.loadItemsConfig();
        }
      },
      (error) => {
        console.log('isLoaded error', error);
      });

    let createdFromBreak = [];
    this.view.entityCopyRequested.subscribe((object: { id, objectConfigUpdate }) => {
      this.itemManager.justDuplicateItemById(object.id, object.objectConfigUpdate).then(item => {
        if (item) {
          createdFromBreak.push(item);
        }
      });
    });
    this.view.editingCancelled.subscribe(() => {
      createdFromBreak.forEach(item => item.removeObject());
      createdFromBreak.length = 0;
    });
    this.view.editStart.subscribe(() => {
      createdFromBreak.length = 0;
    })
    this.view.entityAdded.subscribe((object:{tool, position, id, radius})=>{
        let promise = this.itemManager.addDrawnItem(object);
        promise.then((item: Item) => {
          if (object.id && typeof object.id == 'object' && object.id.polygon) {
            self.view.removeObject(object.id.polygon);
            self.view.removeObject(object.id.border, (result) => {
              this.view.endDrawing();
            });
          } else {
            self.view.removeObject(object.id, (result) => {
              this.view.endDrawing();
            });
          }

          this.calculateItemInputsService.calculateItemInputs(item);

        item.drag_enabled = true;
        self.cd.detectChanges();
        if (!this.uiAdapterService.globalDragEnabled) {
          item.timer = setTimeout(() => {
            if (this.uiAdapterService.globalDragEnabled) {
              return;
            }
            item.drag_enabled = false;
            item.timer = null;
            if (!this.cookieService.checkCookie('isDraggableModalShow')) {
              this.modalControl.currentModal = '.items-lock-modal';
              this.modalControl.openModal({backdrop: true, keyboard: false});
            }
            this.itemManager.isDragTriggered = true;
            self.cd.detectChanges();
          }, 30000);
        }
      })
        .catch((response) => {
          if (response == 'polygon'){
            self.view.removeObject(object.id.polygon);
            self.view.removeObject(object.id.border, (result) => {
              this.view.endDrawing();
            });
            return;
          }
          console.error('Can\'t add object => ', response);
        });
    });
  }

  private forceShowSocketModal() {
    jQuery('#socket-connection-status').modal({backdrop: 'static', keyboard: false, show: true});
    jQuery('#socket-connection-status').data('bs.modal')._config.backdrop = 'static';
    jQuery('#socket-connection-status').data('bs.modal')._config.keyboard = false;
  }


  private setSocketModalVisibility(visibility){
    if (visibility){
      if (this.socketConnectionModalTimer){
        return;
      }
     this.socketConnectionModalTimer = setTimeout(()=>{
       this.forceShowSocketModal();

     }, 20000)
    }
    else{
      if (this.serverConnection.isConnected()){
        jQuery('#socket-connection-status').modal('hide');
        clearTimeout(this.socketConnectionModalTimer);
        this.socketConnectionModalTimer = null;
      }
    }
  }

  private initializeServerConnection() {
    /////////////// EXAMPLE OF SERVER CONNECTION INTERACTION ////////////////
    let self = this;
    this.serverConnection.on('connect', () => {
      console.log("Connected in AppComponent!");
      self.setSocketModalVisibility(false);
      // setTimeout(() => {
      //   console.log('emitting');
      //   this.serverConnection.emit('mousePosition', {x: 1, y: 1}, function () { console.log('callback', arguments); })
      //     .then(function () {
      //       console.log('promise resolved', arguments);
      //     })
      //     .catch(function () {
      //       console.log('promise rejected', arguments);
      //     })
      // }, 5000);
    });
    this.serverConnection.on('disconnect', () => { console.log("Disconnected in AppComponent!"); self.setSocketModalVisibility(true); });
    this.serverConnection.on('reconnect', () => { console.log("Disconnected in AppComponent!"); self.setSocketModalVisibility(false); });
    this.serverConnection.on('error', () => { console.log("Error in socket caught in AppComponent!"); });
    // this.serverConnection.on('addUser', (user) => { console.log("Add user", user); });
    // this.serverConnection.on('removeUser', (sid, user) => { console.log("Remove user", sid, user); });

    let requestCounter = 0;
    this.serverConnection.onBeforeRequest(() => {
      requestCounter++;
      if (requestCounter >= this.serverConnection.maxRequestCount) {
        self.forceShowSocketModal();
      }
    });
    this.serverConnection.onAfterRequest(() => {
      requestCounter--;
      if (requestCounter < 20) {
        self.setSocketModalVisibility(false);
      }
    });

    this.serverConnection.onAction('updateObject', (objectConfig) => {
      let item = this.itemManager.getItemById(objectConfig.id);
      if (item) item.onItemUpdated(objectConfig);
    });
    this.serverConnection.onAction('addObject', (objectConfig) => {
      for (let id in objectConfig) {
        objectConfig[id].id = id;
        let preparedItem = new ItemConfig(objectConfig[id]);
        // preparedItem['id'] = Object.keys(objectConfig)[0];
        // Object.assign(preparedItem, objectConfig[preparedItem['id']]);
        this.itemManager.addItem(preparedItem);
      }
    });
    this.serverConnection.onAction('removeObject', (objectId) => {
      let item = this.itemManager.getItemById(objectId);
      if (item) item.removeObject();
    });
    this.serverConnection.onAction('updatePosition', (objectConfig) => { console.log('updatePosition', objectConfig); });

    this.serverConnection.on('NETWORK_LOST', function () {
      // show modal window
      console.log('NETWORK_LOST');
      self.setSocketModalVisibility(true);
    });
    this.serverConnection.on('NETWORK_RESTORED', function () {
      self.setSocketModalVisibility(false);
      // hide modal window
    });

    this.serverConnection.connect();
    ///////////////////////////////////////////////////////////////
  }
  startDrawing(tool){
    this.view.startDrawing(tool);
  }

  initView(){
    this.view.initializeApp()
  }

  private loadAllIonAssets(){
    setTimeout(()=>{
      this.view.loadIonAssets();
    }, 3000);
  }

  loadItemsConfig() {
    EventConfigProvider().subscribe((eventConfig) => {

      this.view.disableDrawLabelsMode();

      this.initView();
      this.view.drawLabels();

          let helper  = new Cesium.EventHelper();
          let found = false;
          helper.add(this.view.viewer.scene.globe.tileLoadProgressEvent, (event)=>{
            if (event > 0) {
              found = true;
            }
            if (found && event == 0){
              if (this.itemsPositions.length == 1){
                let eventPosition = this.itemsPositions[0];
                eventPosition.height = this.view.getCameraZoomStepHeight(19);
                if (!eventPosition.height){
                  eventPosition.height = this.view.getHeightByZoomLevel(19);
                }
                // this.view.moveCameraTo(eventPosition);
              }
              else{
                // let eventPosition = this.getCalculatedEventCenterPosition();
                // if (eventPosition){
                //   this.view.centerOnPosition(eventPosition, 100, false, 0.1, 19);
                //   setTimeout(function () { window['isESMapLoaded'] = true; }, 2000);
                // }
              }
              setTimeout(function () { window['isEsMapLoaded'] = true; }, 2000);
              if (!window.hasOwnProperty('skipAssetPreload')) {
                this.loadAllIonAssets();
              }
              helper.removeAll();

              if (isBigEventOptimization) {
                this.initItems2(eventConfig);
              } else {
                this.initItems(eventConfig);
              }
            }
          });


      // this.view.viewer.camera.setView({destination: eventPosition});
      // console.log('eventPosition', eventPosition);

      //this.loadAllIonAssets();
      if (window['isNewDesign21']){
         this.view.toggleThreeDMode();
      }
    })
  }

  public queue = [];
  public queueCounter = 0;
  public bounds = new google.maps.LatLngBounds();
  processItemQueue() {
    while (this.queueCounter < 20 && this.queue.length > 0) {
      let itemConfig = this.queue.shift();
      (new Promise(resolve => {
        try {
          let item = new ItemConfig(itemConfig);
          const result = this.itemManager.addItem(item);

          if (result) {
            let itemCenterPosition = item.getObjectConfig().getCenterPosition();
            if (itemCenterPosition && (itemCenterPosition.longitude && itemCenterPosition.longitude !== 0) && (itemCenterPosition.latitude && itemCenterPosition.latitude !== 0)) {
              this.itemsPositions.push(itemCenterPosition);
            }

            if (['polyline', 'polygon'].indexOf(item.getObjectConfig().getToolType()) >= 0) {
              item.getObjectConfig().getPositions().forEach((p: MapPosition) => {
                this.bounds.extend(p.asGoogleMapsLatLng());
              })
            } else {
              this.bounds.extend(item.getObjectConfig().getPosition().asGoogleMapsLatLng());
            }
            let resolved = setTimeout(_ => { resolve(true); }, 1000);
            result.getSubject(Item.AFTER_DRAWN_SUBJECT).subscribe(_ => {
              console.log('e.getEventName()');
              clearTimeout(resolved);
              resolve(true);
            });
          } else {
            resolve(true);
          }
        } catch (e) {
          resolve(true)
        }
        // resolve();
      })).then(processCounter => {
        //if (processCounter) {
          this.queueCounter--;
          if (this.queueCounter <= 0) {
            // setTimeout(_ => {
              this.processItemQueue()
            // }, 50);
          }
        //}
      });
      this.queueCounter++;
    }
    if (this.queueCounter <= 0 && this.queue.length === 0) {
      this.gs.itemsLoaded$ = true;
      this.paywallS.initChangedIconObjectsCounter();
      //need for check empty groups

      window['initialBounds'] = this.bounds;
    }
  }

  async initItems2(eventConfig){
    console.log("INITITEMS2");
    // tile-generation
    this.ngZone.runOutsideAngular(_ => {
      if (eventConfig.hasOwnProperty('items')) {
        let itemsConfig = eventConfig.items;
        let promiseCollection = [];
        for (let group in itemsConfig) {
          if (itemsConfig.hasOwnProperty(group)) {
            for (let k in itemsConfig[group]) {
              if (!itemsConfig[group].hasOwnProperty(k)) {
                continue;
              }
              this.queue.push(itemsConfig[group][k]);
            }
          }
        }

        this.processItemQueue();

        // await Promise.all(promiseCollection);


      }
    });

  }

  initItems(eventConfig){
    let itemAddedCounter = 0;
    let itemsLoaded = false;
    // tile-generation
    var bounds = new google.maps.LatLngBounds();
    if (eventConfig.hasOwnProperty('items')){
      let itemsConfig = eventConfig.items;
      this.itemManager.itemAdded$.pipe(debounceTime(1000)).subscribe(() => {
        if (itemsLoaded) { return; }
        itemsLoaded = true;
        //need for check empty groups
        timer(7000).subscribe(() => {
          this.gs.itemsLoaded$ = true;
          this.paywallS.initChangedIconObjectsCounter();
        });
      });

      for (let group in itemsConfig){
        if (itemsConfig.hasOwnProperty(group)){
          for (let k in itemsConfig[group]){
            if (!itemsConfig[group].hasOwnProperty(k)){
              continue;
            }
            let item = new ItemConfig(itemsConfig[group][k]);
            const result = this.itemManager.addItem(item);
            if (result) {
              itemAddedCounter++;
              let itemCenterPosition = item.getObjectConfig().getCenterPosition();
              if (itemCenterPosition && (itemCenterPosition.longitude && itemCenterPosition.longitude !== 0) && (itemCenterPosition.latitude && itemCenterPosition.latitude !== 0)) {
                this.itemsPositions.push(itemCenterPosition);
              }

              if (['polyline', 'polygon'].indexOf(item.getObjectConfig().getToolType()) >= 0) {
                item.getObjectConfig().getPositions().forEach((p: MapPosition) => {
                  bounds.extend(p.asGoogleMapsLatLng());
                })
              } else {
                bounds.extend(item.getObjectConfig().getPosition().asGoogleMapsLatLng());
              }
            }
          }
        }
      }
    }

    window['initialBounds'] = bounds;

    if (itemAddedCounter === 0) {
      itemsLoaded = true;
      this.gs.itemsLoaded$ = true;
      this.paywallS.initChangedIconObjectsCounter();
    }
  }

  ngAfterViewInit(): void {
    this.storySlidesComponent.setDrawingToolsInstance(this.drawingEditorToolsComponent);
  }
}
